import Vue from 'vue'
import Vuex from 'vuex'

import posts from '@/stores/posts'
import ranking from '@/stores/ranking'

Vue.use(Vuex)

console.log(ranking)

const store = new Vuex.Store({
  state: {
    ...ranking.state,
    ...posts.state,
    activePrime: '',
    activeType: '',
    carclasses: ['R5', 'R3', 'R3L', 'R2', 'R2L', 'N3'],
    trophy: {}
  },
  mutations: {
    ...ranking.mutations,
    ...posts.mutations,
    SET_ACTIVE_PRIME: (state, primeval) => {
      state.activePrime = primeval
    },
    SET_ACTIVE_TYPE: (state, typeval) => {
      state.activeType = typeval
    },
    SET_TROPHY: (state, trophy) => {
      state.trophy = trophy
    }
  },
  actions: {
    ...ranking.actions,
    ...posts.actions,
    setActivePrime: (context, primeval) => {
      context.commit("SET_ACTIVE_PRIME", primeval)
    },
    setActiveType: (context, typeval) => {
      context.commit("SET_ACTIVE_TYPE", typeval)
    },
    setTrophy: (context) => {
      const res = context.state.trophies.slice(-1)
      context.commit('SET_TROPHY', res[0])
    }
  },
  getters: {
    primesByTrophy: (state) => {
      const res = state.primes.filter(prime => prime.TrophyId === state.trophy.id)
      console.log(state.trophy)
      return res
    },
    positionsByPrime: (state) => {
      const primeId = state.activePrime;
      const res = state.positions.filter(position => {
        return position.PrimeId === primeId
      })
      return res
    }
  }
})

store.watch((state) => state.readytrophies, (oldValue, newValue) => {
  console.log('search string is changing')
  store.dispatch('setTrophy')
})

export default store
